export const CREATE_MESSENGER_LINK_URL = 'v2/account/messenger-link/max/'

export type Resp = {
  deep_link: string
  messenger: string
}
